<template>
  <div class="column-manufacture-inner">
    <div class="manufacture-title d-flex align-items-center">
      <span class="select-all">{{ item.name }}</span>
      <i class="ti ti-printer mr-1 print-content" @click.prevent="handlePrint"></i>
    </div>
    <div class="manufacture-gallery mr-3 d-flex flex-column">
      <div class="manufacture-thumbnail" :data-id="item.id" @click="handleManufactureClick">
        <Image :src="item.thumbnail" />
      </div>
      <div v-if="item.gallery?.length > 0" class="gallery d-flex flex-wrap">
        <div v-for="(image, index) in item.gallery.slice(0, 3)" :key="index" class="gallery-item thumbnail" @click="handlePreviewClick">
          <Image :src="image" v-if="index < 2 || item.gallery.length <= 3" />
          <div v-else class="more-thumbnail">+{{ item.gallery.length - 2 }}</div>
        </div>
      </div>
    </div>
    <div v-if="options?.more?.includes('blueprint') && item?.blueprint" class="manufacture-thumbnail mr-3" :data-id="item.id">
      <Image :src="$util.addQueryParam(item?.blueprint, { size: 'xs' })" />
    </div>
    <div class="manufacture-main">
      <div class="manufacture-summary">
        <div class="manufacture-shop-name">
          <label>Shop Name: </label>
          <span class="select-all">{{ item.account_name }}</span>
        </div>
        <div class="manufacture-shop-name">
          <label>Manufacturer: </label>
          <span class="select-all">{{ item.manufacturer_name }}</span>
        </div>
        <div class="quantity">
          <label>Quantity: </label>
          <span class="select-all" :class="{ 'text-danger font-weight-bold': item.quantity > 1 }">{{ item.quantity || '-' }}</span>
        </div>
        <div v-if="parseInt(item.deadline) > 0" class="deadline">
          <label>Deadline: </label>
          <span v-html="item.users?.confirm?.deadline ? this.$util.timestampToDateTime(parseInt(item.users.confirm.deadline)) : '-'" class="select-all"></span>
        </div>
        <div :class="`manufacture-status flag ${item.status} ${item.flag}`">
          <label>Status: </label>
          <span>{{ listStatus?.[item.status]?.label || listStatus?.[item.status]?.text || item.status }}</span>
        </div>
        <div class="print-method">
          <label>Print Method: </label>
          <span class="select-all">{{ item.print_method || '-' }}</span>
        </div>
        <div class="color-batch">
          <label>Color Batch: </label>
          <span class="select-all">{{ item.color_batch || '-' }}</span>
        </div>
        <div class="reference mt-2">
          <a v-if="item?.order_url" target="_blank" :href="item.order_url">Order</a>
          <a v-if="item?.design_url" target="_blank" :href="item.design_url">Design</a>
        </div>
        <div class="row-actions break-normal">
          <span v-for="(action, key, index) in item.more_actions" :key="index" :class="[action.id.replace('.', '-'), action.style || '']">
            <a href="#" :aria-label="action.label" @click.prevent="handleAction(item, action)">
              {{ action.label }}
            </a>
          </span>
        </div>
      </div>
      <div class="manufacture-meta">
        <template v-if="$_.isObjectLike(item.attributes)">
          <div v-for="(attribute, index) in item.attributes" :key="index" :class="`meta-group ${index}`">
            <label class="text-capitalize" :data-attr="index">{{ listAttributes[index] != undefined ? listAttributes[index].label : index }}: </label>
            <span class="select-all">{{ attribute }}</span>
          </div>
        </template>
        <div v-if="item.note.length > 0" class="meta-group note">
          <label>Note: </label>
          <ul>
            <template v-for="(note, index) in item.note" :key="index">
              <li v-if="String(note).length > 0" v-html="renderNote(note)"></li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BodyItemRowAction from '@/components/TableList/Cols/BodyItemRowAction.vue'
import print from '@/helper/print.js'
export default {
  extends: BodyItemRowAction,
  mounted() {
    this.setPriority()
    this.setVerify()
  },
  computed: {
    store() {
      return this.config?.store
    },
    more() {
      return this.config?.more
    },
    item() {
      return this.row?.manufacture || {}
    },
    listStatus() {
      return this.store.getter('extra_attributes.status', {})
    },
    listAttributes() {
      return this.store.getter('extra_attributes.attributes', {})
    },
    options() {
      return this.store.getter('extra_attributes.options.tablelist', {})
    },
    priority() {
      return this.item.priority || 0
    },
    verify() {
      return this.item?.more?.verified
    }
  },
  methods: {
    renderNote(str) {
      let links = this.$util.getLink(str)
      if (links !== null) {
        links.forEach((link) => {
          if (Object.keys(this.$util.options.extension.image).includes(this.$util.getExtensionFromString(link))) {
            str = str.replace(link, `<div class="attached preview d-flex"><img src="${link}" loading="lazy"><a href="${link}" target="_blank">${link}</a></div>`)
          }
        })
      }
      return str
    },
    handlePrint() {
      let order = _.cloneDeep(this.item.refer_order)
      order.manufacturer = this.item?.manufacturer?.user_name
      order.line_items = _.filter(order.line_items, (item) => {
        return this.item?.product_identify == item.identify
      })
      print.order(order)
    },
    handleManufactureClick() {
      this.$emitter.emit('Modal', {
        name: 'manufacture.view',
        data: this.row,
        $el: this.$el instanceof HTMLElement ? this.$el.closest('tr.item') : this.$el.parentNode.closest('tr.item')
      })
    },
    handlePreviewClick() {
      this.$emitter.emit('SubModal', {
        name: 'full-screen-image-preview',
        data: {
          files: Object.values(this.row.manufacture.gallery),
          thumbnail: true
        }
      })
    },
    setPriority() {
      if (!(this.$el instanceof HTMLElement)) return
      let $tr = this.$el.closest('tr')
      $tr.classList.forEach((cls) => {
        if (/^priority-\d+$/.test(cls)) $tr.classList.remove(cls)
      })
      $tr.classList.add(`priority-${this.priority}`)
    },
    setVerify() {
      if (!(this.$el instanceof HTMLElement)) return
      let $tr = this.$el.closest('tr')
      if (this.verify && !$tr.classList.contains('verified')) $tr.classList.add('verified')
      if (!this.verify && $tr.classList.contains('verified')) $tr.classList.remove('verified')
    }
  },
  watch: {
    priority() {
      this.setPriority()
    },
    verify() {
      this.setVerify()
    }
  }
}
</script>
<style lang="scss">
.table-list.manufacture {
  .attached.preview {
    padding-top: 5px;
    img {
      width: 60px;
      height: 60px;
      min-width: 60px;
      min-height: 60px;
      object-fit: contain;
      border: 1px solid #ccc;
      border-radius: var(--border-radius, 0.25rem);
    }
    a {
      padding-left: 10px;
    }
  }
  .reference {
    margin-top: 5px;
    a {
      height: auto;
      width: auto;
      font-size: 11px;
      cursor: pointer;
      padding: 2px 10px;
      margin: 0 5px 5px 0;
      border-radius: var(--border-radius, 0.25rem);
      display: inline-block;
      color: #333;
      background: #e4e4e4;
    }
  }
  .print-content {
    cursor: pointer;
    font-size: 16px;
    margin: 0 5px;
    margin-top: -1px;
    display: none;
  }
  tr {
    &:hover {
      .print-content {
        display: inline-block;
      }
    }
    &.verified {
      background-color: #dfe7ff !important;
      &:nth-child(odd) {
        background-color: #cedaff !important;
      }
    }
    &.priority-1 {
      background-color: #fde5c3 !important;
      &:nth-child(odd) {
        background-color: #ffd9a7 !important;
      }
    }
  }
  .manufacture-thumbnail {
    cursor: pointer;
  }
  .manufacture-gallery {
    width: 200px;
    .gallery {
      margin: -5px;
      margin-top: 5px;
    }
    .gallery-item {
      width: 60px;
      height: 60px;
      margin: 5px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
      }
    }
    .more-thumbnail {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: #ddd;
      font-size: 18px;
      font-weight: bold;
      color: #888;
    }
  }
  .meta-group.note {
    white-space: pre-wrap;
  }
}
.manufacture-vendor-mapping {
  .vendor-mapping-inner {
    border: 1px dashed #ccc;
    padding: 10px 15px;
    border-radius: var(--border-radius, 0.25rem);
    min-width: 250px;
    &:empty {
      display: none;
    }
    .account-server {
      span {
        text-transform: capitalize;
      }
    }
  }
}
</style>
